export default {
    adjustments: {
        title: "Regolazioni",
        reset: "Ripristino",
        light: {
            title: "Luce",
            brightness: "Luminosità",
            contrast: "Contrasto",
            shadows: "Ombre",
        },
        color: {
            title: "Colore",
            saturation: "Saturazione",
            temperature: "Temperatura",
            blacks: "Neri",
            whites: "Bianchi",
        },
        detail: {
            title: "Dettaglio",
            clarity: "Chiarezza",
            sharpness: "Nitidezza",
            blur: "Sfocato",
        },
    },
};
